<ul class="social-media mb-0">
	<li *ngFor="let media of socialMedia">
		<a class="btn btn-sm text-primary icon" [href]="media.url" target="_blank" rel="noopener noreferrer">
			<span class="sr-only">{{ media.legend }}</span>
			<i class="fab" [class]="media.name"></i>
		</a>
	</li>
</ul>
